module.exports = __webpack_public_path__ + "img/weixin1.2c927797.png";